export default {
  title: '3D Models',
  heading: 'Error 404',
  error1: 'The page cannot be found',
  error2: 'Please check the address or go ',
  error3: ' back to the homepage',
  description: 'You have the opportunity to see the product as a 3D model!',
}